import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App.jsx"
import registerSW from "./serviceWorker/register"
import reportWebVitals from "./reportWebVitals"

// Set page title from environment variable or default
const pageTitle = import.meta.env.VITE_PAGE_TITLE || "St Jeans OMS"
document.title = pageTitle

// This file runs on initial site opening, or on refreshing of any page.
// Navigating between pages in the app does not re-run this file.

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

registerSW()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

